import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';

export default class SinglePhotoPhotoSectionCheckoutDescription extends React.Component {
    static propTypes = {
        photo: PropTypes.shape({
            description: PropTypes.string.isRequired,
            averageRating: PropTypes.number,
            ratingsCount: PropTypes.number,
            address: PropTypes.string
        }).isRequired
    };
    static defaultProps = {};

    render() {
        const { description, averageRating, ratingsCount, address } = this.props.photo;

        let roundedAverageRating = Math.round((averageRating || 0) * 100) / 100;
        roundedAverageRating = roundedAverageRating >= 1 ? roundedAverageRating : 1;

        return (
            <div className="single-photo-photo-section-checkout-description row">
                {!ratingsCount ? null :
                    <div className="rating-container" itemProp="aggregateRating" itemScope itemType="http://schema.org/AggregateRating">
                        Rating:&nbsp;
                        <span itemProp="ratingValue">{roundedAverageRating}</span>&nbsp;
                        out of <span itemProp="bestRating">5</span>&nbsp;
                        based on <span itemProp="ratingCount">{ratingsCount}</span> user ratings.
                    </div>
                }
                <h2 className="photo-description">{description}</h2>
                {address ? <p className="photo-address">Photo was taken at address: {address}</p> : null}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/single-photo/Photo/components/CheckoutDescription/index.js